import { useMutation } from "@tanstack/react-query";
import type {
  Attachment,
  FeedbackCategoryId,
} from "src/components/general/FeedbackDialog/FeedbackDialog.types";
import { dfetch } from "src/utils/dfetch.ts";

export type SubmitFeedbackParams = {
  category: FeedbackCategoryId;
  feedback: string;
  page_url: string;
  attachment: Attachment | null;
};

/**
 * POST `/api/feedback` — emails the feedback (and any screenshot) to the support
 * inbox using the System Settings SMTP config. Resolves (204) once the email is
 * queued for delivery; rejects with 503 when SMTP is not configured. `dfetch`
 * surfaces a toast on a non-2xx response, so callers can safely confirm success
 * in `onSuccess` / after `await`.
 */
export const useSubmitFeedbackMutation = () =>
  useMutation({
    mutationFn: (params: SubmitFeedbackParams) =>
      dfetch("/api/feedback", params, "POST"),
  });
